<div class="dialog-container" *ngIf="dialogContent">
  <mat-dialog-content>
      <div *ngIf="dialogContent.heading!==null" class="image-header">
          <img class="image-inner" [attr.src]="dialogContent.imageUrl" alt="" />
      </div>
      <div class="heading" [ngClass]="{'alert': dialogContent.type===dialogType.AlertConfirmation}">
          {{dialogContent.heading | translate}}
      </div>
      <div class="sub-heading">
        <span [innerHTML]="dialogContent.subHeading | translate"> </span>
      </div>
      <div *ngIf="dialogContent.type === dialogType.AlertConfirmation" class="warning-section">
          {{dialogContent.warningSection | translate}}
      </div>
  </mat-dialog-content>
  <ng-content></ng-content>
  <div class="action-section">
      <button *ngIf="dialogContent.type !== dialogType.Message" mat-raised-button
          class="sus-base-button outlined-button secondary sus-base-button-large sus-base-button-dialog-large" (click)="onCancel()">
              {{dialogContent.secondaryButtonText | translate}}
      </button>
      <button mat-raised-button class="sus-base-button primary sus-base-button-large sus-base-button-dialog-large"
          [ngClass]="{'warn': dialogContent.type===dialogType.AlertConfirmation}" (click)="onConfirm()">
              {{dialogContent.primaryButtonText | translate}}
      </button>
  </div>
  <div class="footer-section" *ngIf="dialogContent.hasFooter">
      <ng-content select="[footer]"></ng-content>
  </div>
</div>
